import { goalsQuery } from '../../graphql/queries/grid/domain';
import { GoalsQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class GoalsDataProvider extends BaseDataProvider {
    public fetchMetricsGoals(login: string, campaignIdIn?: Array<string>): Promise<GoalsQuery> {
        const filter: { campaignIdIn?: Array<string> } = {};

        if (campaignIdIn && campaignIdIn.length) {
            filter.campaignIdIn = campaignIdIn;
        }

        return this.createQuery<GoalsQuery>(goalsQuery, {
            variables: {
                login,
                goalsInput: {
                    filter
                }
            }
        }).then(result => result.data);
    }
}
